ux-table-data-column {
  display: none;
}
